import AccountAddress from "@/components/address/AddressManage";
import styles from "./index.module.scss";
import { Helmet } from "react-helmet";
import { useTranslation } from "@/i18n/client";

const ShippingAddress = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.box}>
      <Helmet>
        <title>{t("seo.title.address")} | Joybuy</title>
        <meta name="description" content={t("seo.description.allDesc")} />
      </Helmet>
      <AccountAddress isPersonModal={true} />
    </div>
  );
};
export default ShippingAddress;
